import { AuditEventCategory, AuditItem } from "@dto/auditResponse.dto";
import { useState } from "react";
import { useAppGlobStore } from "src/appGlobalStore";
import { XmTableScope } from 'src/component/table/XmTable';
import { ColProps, XmTableEntry } from "src/component/table/tableTypes";
import { TextUtil } from "src/util/TextUtil";

export interface TableData extends AuditItem {
  inSeconds: number;
  rowKey: number;
  category?: AuditEventCategory;
}

interface AuditTableProps {
  data: TableData[];
  allData: TableData[];
  loading: boolean;
}

const AuditLogTable = ({ data, allData, loading }: AuditTableProps) => {
  const [tscope] = useState(() => new XmTableScope<TableData>());

  const columns: ColProps<XmTableEntry & TableData>[] = [
    { /// User
      title: "User",
      dataIndex: "user",
      key: "user",
      minWidth: '6em',
      filters: allData.map(log => log.user).filter((element, index) => (allData.map(log => log.user).indexOf(element) === index)).map(user => ({ text: user, value: user })),
      onFilter: (value, record) => value === record.user
    },
    { /// IP
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      minWidth: '6em',
    },
    { /// Time
      title: "Time",
      dataIndex: "time",
      key: "time",
      minWidth: "12em",
      sorter: (a, b) => a.inSeconds - b.inSeconds,
      defaultSortOrder: "descend"
    },
    { /// Event
      title: "Event",
      dataIndex: "event",
      key: "event",
      minWidth: "11em",
      sorter: (a, b) => a.event.localeCompare(b.event),
      filter: { field: ['event'] }
    },
    { /// Affected
      title: "Affected",
      dataIndex: "affected",
      key: "affected",
      minWidth: "11em",
      onCell: (() => ({ style: { minWidth: '3em' } })),
      sorter: (a, b) => a.event.localeCompare(b.event),
      render: (text: string) => TextUtil.trimMiddle(text),
      trim: true
    },
  ];

  const setRowKey = (record: TableData) => record.rowKey;

  return (
    <tscope.XmTable
      key="audit-table"
      rowKey={setRowKey}
      className="audit-table"
      loading={loading}
      columns={columns}
      dataSource={data}
      pagination={false}
      scroll={{ y: useAppGlobStore.getState().mainScrollRef.current.clientHeight - 50 }}
    />
  );
};

export default AuditLogTable;
